import PortfolioConfigData from "config/portfolio-config.json";
import ComposizioneDelPortfolio from "./components/ComposizioneDelPortafoglio";
import React from "react";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import { FinecoDownloadButton } from "pages/assistant/components/FinecoDownloadButton";
import { useTranslation } from "react-i18next";
import { useComparisonLabels } from "../../compare/ComparisonLabelsContext";

type SectionChildrenProps = {
  reportData: any;
  reportData2?: any;
  requestGenerateExcel?: () => void;
  generatingExcel?: boolean;
};
const ComposizioneDelPortafoglioContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
  requestGenerateExcel,
  generatingExcel = false,
}) => {
  const { t } = useTranslation();
  const labels = useComparisonLabels();
  if (!reportData) {
    return <></>;
  }

  return (
    <>
      <div
        className={commonStyles.sectionContainer}
        style={{ marginTop: reportData2 ? 28 : 0 }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 className={commonStyles.titleChart}>
            {PortfolioConfigData.portfolio.data.strumenti_fondi.label}
            {reportData2 && ` ${labels.portfolio1.replace(/^portafoglio\s*/i, '')}`}
          </h3>
        </div>
        <ComposizioneDelPortfolio
          strumenti_fondi={reportData.portafoglio.strumenti_fondi}
          strumenti_obbligazionari={
            reportData.portafoglio.strumenti_obbligazionari
          }
          strumenti_azioni={reportData.portafoglio.strumenti_azioni}
          strumenti_certificati={reportData.portafoglio.strumenti_certificati}
          strumenti_polizze={reportData.portafoglio.strumenti_polizze}
          countervalue={reportData.countervalue}
          isInsurance={reportData.portafoglio.is_insurance_portfolio === true}
        />
        {requestGenerateExcel && !reportData2 && (
          <div style={{ marginTop: 16 }}>
            <FinecoDownloadButton
              click={requestGenerateExcel}
              copy={
                !generatingExcel
                  ? t("actions.generateExcel")
                  : t("actions.submitting")
              }
            />
          </div>
        )}
      </div>

      {reportData2 && (
        <>
          <div className="force-page-break"></div>
          <div
            className={commonStyles.sectionContainerComposizioneDelPortafoglio}
          >
            <h3 className={commonStyles.titleChart} style={{ marginTop: 40 }}>
              {PortfolioConfigData.portfolio.data.strumenti_fondi.label}
              {` ${labels.portfolio2.replace(/^portafoglio\s*/i, '')}`}
            </h3>
            <ComposizioneDelPortfolio
              strumenti_fondi={reportData2.portafoglio.strumenti_fondi}
              strumenti_obbligazionari={
                reportData2.portafoglio.strumenti_obbligazionari
              }
              strumenti_azioni={reportData2.portafoglio.strumenti_azioni}
              strumenti_certificati={reportData2.portafoglio.strumenti_certificati}
              strumenti_polizze={reportData2.portafoglio.strumenti_polizze}
              countervalue={reportData2.countervalue}
              isInsurance={reportData2.portafoglio.is_insurance_portfolio === true}
            />
            <div style={{ marginBottom: 20 }}></div>
          </div>
        </>
      )}
    </>
  );
};
export default React.memo(
  ComposizioneDelPortafoglioContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    // Custom comparison function
    return prevProps.reportData === nextProps.reportData;
  },
);
